import { makeStyles } from '@material-ui/core/styles';
import bg from "../assets/images/bg_small.jpg"

export const useStyles = makeStyles(theme => ({
  takisGridContainer: {
    width: '100%',
    backgroundImage: `linear-gradient(to top, ${theme.palette.gridPurple} 0%, ${theme.palette.gridPurple} 100%), url(${bg})`,
    backgroundBlendMode: 'multiply',
    position: 'relative',
    paddingBottom: '8rem',
    '&:before': {
			width: '100%',
			height: '1rem',
			content: '""',
			position: 'absolute',
			clipPath: 'polygon(0% 0%, 0% 100%, 100% 0%)',
			backgroundSize: 'cover',
			backgroundColor: theme.palette.yellow,
			top: '-0.063rem'
		},
    '&.flattop':{
      '&:before': {
        backgroundColor: 'red',
        display: "none"
      },
		},
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      paddingBottom: '9rem',
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      paddingBottom: '10rem',
    }
  },
  title: {
    fontFamily: 'Veneer, Arial',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '3.8rem',
    color: theme.palette.yellow,
    margin: '0 0 1rem',
    textAlign: "center",
    height: "auto"
  },
  takisGrid: {
    padding: "2.5rem 0 0.5rem",
    maxWidth: theme.limits.lg,
    margin: '0 auto',
    position: 'relative'
  },
  takisGridItemContainer: {
    marginBottom: "2rem",
    listStyle: "none",
  },
  gridDividerMargin: {
    height: '6.5rem'
  },
  gridDividerMarginHome: {
    height: '0.063rem'
  },
  takisGridNoPadding: {
    paddingInlineStart: "0"
  }
}));
